export enum FelloTemplateSegmentType {
  TOKEN = "TOKEN",
  TEXT = "TEXT",
  HTML = "HTML"
}

export interface FelloTemplateSegment {
  type: FelloTemplateSegmentType;
}
